import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NavigationConfig, NavigationItem} from '@common-ui-lib';
import {ActivatedRoute, Router} from '@angular/router';
import {AppNameEnum} from '@nachdigal';
import {ComponentHelper, NavigationService} from '@utils-lib';
import {LoaderService} from '../../service/loader.service';
import {Subscription} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Component({
    selector: 'common-ui-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, OnDestroy {

    @Input()
    public navigationConfig: NavigationConfig;

    @Input()
    public disableNavigation = false;

    public appName: string;
    public routerLink = environment.redirectPath;
    public mandantenName = 'Mandantenname nicht bekannt';
    public mandantenNr: string;
    public beraterNr: string;

    private subscription: Subscription;
    private currentRoute: string;

    constructor(private readonly router: Router,
                protected readonly activatedRoute: ActivatedRoute,
                private readonly navigationService: NavigationService,
                private readonly loadingService: LoaderService) {
        this.currentRoute = this.router?.getCurrentNavigation()?.extractedUrl?.root?.children?.primary?.segments?.pop()?.path;
    }

    public ngOnInit(): void {
        this.beraterNr = this.activatedRoute.snapshot.data.document.element_of_order.consultant_number;
        this.mandantenNr = this.activatedRoute.snapshot.data.document.element_of_order.master_client_number;

        this.subscription = this.navigationService.isMandantNameUpdated.subscribe(mandantName => {
            if (mandantName !== '') {
                this.mandantenName = mandantName;
            }
        });
        if (this.activatedRoute?.snapshot?.data?.document?.client_name !== null &&
            this.activatedRoute?.snapshot?.data?.document?.client_name !== '') {
            this.mandantenName = this.activatedRoute.snapshot.data.document.client_name;
        }

        switch (ComponentHelper.getAppEnum(this.activatedRoute.snapshot)) {
            case AppNameEnum.FragebogenEUn: {
                this.appName = 'FsE – Aufnahme gewerbliche Tätigkeit';
                break;
            }
            case AppNameEnum.FragebogenKapG: {
                this.appName = 'FsE – Gründung Kapitalgesellschaft / Genossenschaft';
                break;
            }
            case AppNameEnum.FragebogenPersG: {
                this.appName = 'FsE – Gründung Personengesellschaft/-gemeinschaft';
                break;
            }
            case AppNameEnum.FragebogenBetPG: {
                this.appName = 'FsE – Beteiligung Personengesellschaft/-gemeinschaft';
                break;
            }
            case AppNameEnum.FragebogenKapGAus: {
                this.appName = 'FsE – Körperschaft nach ausländischem Recht';
                break;
            }
            default: {
                this.appName = 'Fragebogentyp nicht bekannt';
                break;
            }
        }
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    public onNavigationClick(route: string, $event?: Event): void {
        if (!!$event) {
            let url = this.router.url;
            url = url.substring(0, url.lastIndexOf('\/'));
            url = `${url}/${route}`;
            this.router.navigateByUrl(url);
        }
        if (route !== this.currentRoute) {
            if (route === 'antrag-versenden') {
                this.loadingService.isLoading = {isLoading: true};
            }
            this.currentRoute = route;
        }
    }

    public navigateToOverview(): void {
        this.router.navigate([environment.redirectPath]);
    }
    protected isVisible(item : NavigationItem){
      return ComponentHelper.isVisible(item);
    }

}
